import { useChangeSearch, useSearch } from '@btime/react-contexts'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SearchInput from '../../../components/form/SearchInput'
import ScreenDropdown from '../../../containers/screens/ScreenDropdown'

const ControlBar = ({ selectedScreen, children }) => {
  const changeSearch = useChangeSearch()
  const search = useSearch()

  return (
    <>
      <Separator weight={4} />
      <Grid justify="space-between" gutter={0.4}>
        <Col>
          <ScreenDropdown selected={selectedScreen} screen="webhook" />
        </Col>
        <Col>{children}</Col>
        <Col flex={3} />
        <Col flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </Col>
      </Grid>
      <Separator weight={4} />
    </>
  )
}

export default ControlBar
